<template>
    <div>
        <img alt="Marchword" src="../assets/mls_logo.jpg">
    </div>
</template>